// import PropTypes from 'prop-types'
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Header from '../components/Header';
import Display from '../components/Display';
import About from '../components/About';
import Skill from '../components/Skill';
// import Schooling from '../components/Schooling';
import Projects from '../components/Projects';
import Contato from '../components/Contato';

import '../styles/App.css';

export default class App extends Component {

  render() {
    return (
      <>
        <Header />
        <Display />
        <About />
        <Skill />
        {/* <Schooling /> */}
        <Projects />
        <Contato />
      </>
    )
  };
};